<template>
  <div data-sbLogPagina="">
    <div v-if="!modoBuscaDefinido" class="carregando-modo-busca">
      <b-spinner variant="secondary" label="Carregando produtos..."></b-spinner>
    </div>

    <lista-produtos-legada
      v-else-if="!servicoBuscaAtivo"
      :id="id"
      :results-per-page="resultsPerPage"
      :cliente_codigo="cliente_codigo"
      :cd_filial="cd_filial"
      @onAddMga="adicionarMga"
      @onAddItj="adicionarItj"
      @onAdd="adicionar"
    >
      <template v-slot:segundaColuna>
        <slot name="segundaColuna"></slot>
      </template>
      <template v-slot:terceiraColuna>
        <slot name="terceiraColuna"></slot>
      </template>
      <template v-slot:addButton="propriedadesSlot">
        <slot name="addButton" :data="propriedadesSlot.data"></slot>
      </template>
    </lista-produtos-legada>

    <template v-else>
      <barra-busca-produtos
        ref="barraBusca"
        :mostrar-segunda-coluna="temSegundaColuna"
        :mostrar-terceira-coluna="temTerceiraColuna"
        :somente-favoritos="somenteFavoritos"
        :termo-busca="termoBusca"
        :carregando-sugestoes="carregandoSugestoes"
        :mostrar-sugestoes="mostrarSugestoes"
        :sugestoes="sugestoes"
        :id-busca="idBusca"
        @alterarFavoritos="alterarFavoritos"
        @alterarTermo="termoBusca = $event"
        @teclaBusca="carregarSugestoes"
        @limparBusca="limparBusca"
        @usarSugestao="usarSugestao"
        @fecharSugestoes="mostrarSugestoes = false"
      >
        <template v-slot:segundaColuna>
          <slot name="segundaColuna"></slot>
        </template>
        <template v-slot:terceiraColuna>
          <slot name="terceiraColuna"></slot>
        </template>
      </barra-busca-produtos>

      <b-row class="mb-3">
        <b-col md="2">
          <filtros-servico-busca
            :tem-filtros-ativos="temFiltrosAtivos"
            :filtros="filtrosServicoBusca"
            :selecionados="filtrosServicoBuscaSelecionados"
            @alterar="alterarFiltroServicoBusca"
            @limpar="limparTodosFiltros"
          />
        </b-col>

        <b-col md="10">
          <grade-resultados-produtos
            :resultados="resultados"
            :carregando="carregandoProdutos"
            :cliente-codigo="cliente_codigo"
            :codigo-filial="cd_filial"
            @adicionarMga="adicionarMga"
            @adicionarItj="adicionarItj"
            @adicionar="adicionar"
            @ocultarProduto="ocultarProduto"
            @favoritar="atualizarFavorito"
          >
            <template v-slot:addButton="propriedadesSlot">
              <slot name="addButton" :data="propriedadesSlot.data"></slot>
            </template>
          </grade-resultados-produtos>

          <sentinela-rolagem-infinita
            :ativo="podeCarregarMais"
            :carregando="carregandoProdutos"
            @visivel="carregarProdutos"
          />
        </b-col>
      </b-row>

      <go-to-top></go-to-top>
    </template>
  </div>
</template>

<script>
import GoToTop from "@/components/ui/GoToTop.vue";
import Analytics from "@/services/analytics";
import Produto from "@/services/produto";
import ServicoBuscaSession from "@/services/servicoBuscaSession";
import barraBuscaProdutos from "./componentes/barraBuscaProdutos";
import filtrosServicoBusca from "./componentes/filtrosServicoBusca";
import gradeResultadosProdutos from "./componentes/gradeResultadosProdutos";
import listaProdutosLegada from "./componentes/listaProdutosLegada";
import sentinelaRolagemInfinita from "./componentes/sentinelaRolagemInfinita";

export default {
  name: "ProductList",
  components: {
    GoToTop,
    barraBuscaProdutos,
    filtrosServicoBusca,
    gradeResultadosProdutos,
    listaProdutosLegada,
    sentinelaRolagemInfinita,
  },
  props: {
    id: {
      type: String,
      default: "ProductList",
    },
    resultsPerPage: {
      type: Number,
      default: 10,
    },
    cliente_codigo: {
      type: Number,
      default: 0,
    },
    cd_filial: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      temporizadorSugestoes: null,
      sugestoes: [],
      carregandoProdutos: false,
      carregandoSugestoes: false,
      mostrarSugestoes: false,
      termoBusca: "",
      somenteFavoritos: false,
      dadosBusca: {
        params: {
          search: {},
          page: 1,
          resultsPerPage: this.resultsPerPage,
          sortColumn: null,
          sortDirection: null,
          cd_filial: this.cd_filial,
          cliente_codigo: this.cliente_codigo,
        },
      },
      resultadoBusca: {},
      resultados: [],
      idBusca: ServicoBuscaSession.obterSearchId(),
      modoBusca: "carregando",
      filtrosServicoBusca: [],
      filtrosServicoBuscaSelecionados: {},
    };
  },
  computed: {
    temSegundaColuna() {
      return !!(this.$scopedSlots.segundaColuna || this.$slots.segundaColuna);
    },
    temTerceiraColuna() {
      return !!(this.$scopedSlots.terceiraColuna || this.$slots.terceiraColuna);
    },
    servicoBuscaAtivo() {
      return this.modoBusca === "servicoBusca";
    },
    modoBuscaDefinido() {
      return this.modoBusca !== "carregando";
    },
    temTermoBusca() {
      return this.normalizarTexto(this.termoBusca) !== "";
    },
    temFiltrosServicoBusca() {
      return Object.keys(this.filtrosServicoBuscaSelecionados).some((campo) => {
        return (this.filtrosServicoBuscaSelecionados[campo] || []).length > 0;
      });
    },
    temFiltrosAtivos() {
      return (
        this.temTermoBusca ||
        this.somenteFavoritos === true ||
        this.temFiltrosServicoBusca
      );
    },
    podeCarregarMais() {
      const totalPaginas = Number(this.resultadoBusca.totalPages || 0);
      const proximaPagina = Number(this.dadosBusca.params.page || 1);

      return totalPaginas > 0 && proximaPagina <= totalPaginas;
    },
  },
  created() {
    this.carregarProdutos();
  },
  beforeDestroy() {
    clearTimeout(this.temporizadorSugestoes);
  },
  methods: {
    normalizarTexto(valor) {
      return String(valor == null ? "" : valor).trim();
    },
    carregarProdutos(dados = null, forcarPesquisa = false) {
      const dadosRequisicao = dados || this.dadosBusca;

      if (
        this.carregandoProdutos ||
        (!forcarPesquisa && !this.podeCarregarMais && this.modoBuscaDefinido)
      ) {
        return;
      }

      this.carregandoProdutos = true;
      if (Number(dadosRequisicao.params.page) === 1) {
        this.resultadoBusca.totalResults = -1;
      }

      dadosRequisicao.params.cliente_codigo = this.obterCodigoCliente();
      dadosRequisicao.params.produtos_favoritos = this.somenteFavoritos;
      let carregarProximaPagina = false;

      Produto.getListaProdutos(dadosRequisicao)
        .then((response) => {
          const resultado = response.data.data || {};
          const produtosPagina = Object.keys(resultado.results || {}).map(
            (chave) => resultado.results[chave]
          );

          this.idBusca = ServicoBuscaSession.obterSearchId();
          this.resultadoBusca = resultado;
          this.aplicarModoBusca(resultado);
          this.adicionarResultados(produtosPagina);

          if (this.servicoBuscaAtivo) {
            Analytics.trackViewItemList(produtosPagina, this.$store);
          }

          const paginaAtual = Number(resultado.page || dadosRequisicao.params.page);
          const totalPaginas = Number(resultado.totalPages || 0);
          this.dadosBusca.params.page = paginaAtual + 1;

          carregarProximaPagina =
            this.servicoBuscaAtivo &&
            produtosPagina.length === 0 &&
            paginaAtual < totalPaginas;
        })
        .catch((erro) => {
          this.tratarErroBusca(erro);
        })
        .finally(() => {
          this.carregandoProdutos = false;

          if (carregarProximaPagina) {
            this.carregarProdutos();
          }
        });
    },
    obterCodigoCliente() {
      if (this.cliente_codigo && this.cliente_codigo !== 0) {
        return this.cliente_codigo;
      }

      return this.$store.state.carrinhoitj.cliente_codigo == null
        ? this.$store.state.carrinho.cliente_codigo
        : this.$store.state.carrinhoitj.cliente_codigo;
    },
    adicionarResultados(produtos) {
      const codigosExistentes = this.resultados.reduce((codigos, produto) => {
        codigos[String(produto.codigo)] = true;
        return codigos;
      }, {});

      produtos.forEach((produto) => {
        const codigo = String(produto.codigo);
        if (!codigosExistentes[codigo]) {
          this.resultados.push(produto);
          codigosExistentes[codigo] = true;
        }
      });
    },
    tratarErroBusca(erro) {
      if (this.somenteFavoritos) {
        this.$helper.showMsg(
          "Nao foram encontrados produtos favoritos. Para exibir todos produtos, desmarque o filtro 'Produtos Favoritos'",
          "warning"
        );
      } else {
        this.$helper.showErrorResponse(erro);
      }

      if (erro.response && erro.response.status === 404 && erro.response.data) {
        this.resultados = [];
        this.limparBusca();
      }
    },
    aplicarModoBusca(resultado) {
      if (resultado.servicoBuscaAtivo) {
        this.modoBusca = "servicoBusca";
        this.$emit("alterarModoBusca", true);
        this.filtrosServicoBusca = Array.isArray(resultado.filtrosServicoBusca)
          ? resultado.filtrosServicoBusca
          : [];
        return;
      }
      this.modoBusca = "legado";
      this.$emit("alterarModoBusca", false);
      this.filtrosServicoBusca = [];
      this.filtrosServicoBuscaSelecionados = {};
    },
    alterarFavoritos(valor) {
      this.somenteFavoritos = valor === true || valor === "true";
      this.reiniciarBusca();
    },
    carregarSugestoes(evento) {
      this.sugestoes = [];

      if (evento.key === "Enter") {
        this.buscarTexto();
        return;
      }

      clearTimeout(this.temporizadorSugestoes);
      if (!this.temTermoBusca) {
        this.mostrarSugestoes = false;
        return;
      }

      this.temporizadorSugestoes = setTimeout(() => {
        this.carregandoSugestoes = true;
        Produto.getSearchSuggestions(this.termoBusca)
          .then((response) => {
            this.idBusca = ServicoBuscaSession.obterSearchId();
            this.sugestoes = response.data.data || [];
            this.mostrarSugestoes = true;
          })
          .catch((erro) => {
            console.log(erro);
          })
          .finally(() => {
            this.carregandoSugestoes = false;
            this.$refs.barraBusca.focarBusca();
          });
      }, 500);
    },
    criarParametrosBusca() {
      const parametros = {};

      Object.keys(this.filtrosServicoBuscaSelecionados).forEach((campo) => {
        const valores = this.filtrosServicoBuscaSelecionados[campo] || [];
        if (valores.length > 0) {
          parametros[campo] = valores.join(",");
        }
      });

      if (this.temTermoBusca) {
        parametros.content = this.termoBusca;
      }

      return parametros;
    },
    buscarTexto() {
      if (this.temTermoBusca) {
        Analytics.trackSearch(this.normalizarTexto(this.termoBusca), this.$store);
      }

      this.rolarParaTopoProdutos();
      this.mostrarSugestoes = false;
      this.reiniciarBusca();
    },
    reiniciarBusca() {
      this.resultados = [];
      this.dadosBusca.params.search = this.criarParametrosBusca();
      this.dadosBusca.params.page = 1;
      this.dadosBusca.params.sortColumn = "";
      this.dadosBusca.params.sortDirection = "asc";
      this.dadosBusca.params.resultsPerPage = this.resultsPerPage;
      this.carregarProdutos(this.dadosBusca, true);
    },
    limparBusca() {
      this.termoBusca = "";
      this.somenteFavoritos = false;
      this.mostrarSugestoes = false;
      this.reiniciarBusca();
    },
    limparTodosFiltros() {
      this.filtrosServicoBuscaSelecionados = {};
      this.termoBusca = "";
      this.somenteFavoritos = false;
      this.mostrarSugestoes = false;
      this.reiniciarBusca();
    },
    alterarFiltroServicoBusca(item, selecionado) {
      const campo = item.id;
      const valor = this.normalizarTexto(item.valor);

      if (!campo || !valor) {
        return;
      }

      const filtros = Object.assign({}, this.filtrosServicoBuscaSelecionados);
      const valores = filtros[campo] ? filtros[campo].slice() : [];
      const indice = valores.indexOf(valor);

      if (selecionado && indice === -1) {
        valores.push(valor);
      } else if (!selecionado && indice > -1) {
        valores.splice(indice, 1);
      }

      if (valores.length > 0) {
        filtros[campo] = valores;
      } else {
        delete filtros[campo];
      }

      this.filtrosServicoBuscaSelecionados = filtros;
      this.reiniciarBusca();
    },
    usarSugestao(sugestao) {
      this.termoBusca = /^\d/.test(sugestao)
        ? sugestao.replace(/^\d+\s*[-_]*\s*/, "")
        : sugestao;
      this.buscarTexto();
    },
    rolarParaTopoProdutos() {
      const topo = document.getElementById("topo-lista-produtos");
      if (topo && topo.scrollIntoView) {
        topo.scrollIntoView({ block: "start" });
      }
    },
    adicionarMga(dados) {
      this.$emit("onAddMga", dados);
    },
    adicionarItj(dados) {
      this.$emit("onAddItj", dados);
    },
    adicionar() {
      this.$emit("onAdd", false);
    },
    ocultarProduto(codigoProduto) {
      const indice = this.resultados.findIndex(
        (produto) => produto.codigo == codigoProduto
      );
      if (indice > -1) {
        this.resultados.splice(indice, 1);
      }
    },
    atualizarFavorito(codigoProduto, favorito) {
      const produto = this.resultados.find(
        (item) => item.codigo == codigoProduto
      );
      if (produto) {
        produto.favorito = favorito;
      }
    },
  },
};
</script>

<style scoped>
.carregando-modo-busca {
  min-height: 10rem;
  padding: 4rem 0;
  text-align: center;
}
</style>
